import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios'

const API_BASE_URL = import.meta.env.PROD
  ? 'https://sentinel-api.darkhorseinfosec.com'
  : 'http://localhost:8100'

class ApiClient {
  private client: AxiosInstance
  private currentOrgId: number | null = null

  constructor() {
    this.client = axios.create({
      baseURL: API_BASE_URL,
      timeout: 30000,
      headers: {
        'Content-Type': 'application/json',
      },
    })

    // Request interceptor
    this.client.interceptors.request.use(
      (config: InternalAxiosRequestConfig) => {
        // Add org_id header if set
        if (this.currentOrgId) {
          config.headers['X-Org-ID'] = this.currentOrgId.toString()
        }
        return config
      },
      (error) => {
        return Promise.reject(error)
      }
    )

    // Response interceptor
    this.client.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response) {
          const message = error.response.data?.detail || error.message
          console.error('API Error:', message)
          throw new Error(message)
        } else if (error.request) {
          console.error('Network Error:', error.message)
          throw new Error('Network error - please check your connection')
        } else {
          console.error('Request Error:', error.message)
          throw error
        }
      }
    )
  }

  setOrgId(orgId: number | null) {
    this.currentOrgId = orgId
  }

  getOrgId(): number | null {
    return this.currentOrgId
  }

  async get<T>(url: string, params?: any): Promise<T> {
    const response = await this.client.get<T>(url, { params })
    return response.data
  }

  async post<T>(url: string, data?: any): Promise<T> {
    const response = await this.client.post<T>(url, data)
    return response.data
  }

  async put<T>(url: string, data?: any): Promise<T> {
    const response = await this.client.put<T>(url, data)
    return response.data
  }

  async delete<T>(url: string): Promise<T> {
    const response = await this.client.delete<T>(url)
    return response.data
  }
}

export const apiClient = new ApiClient()
export default apiClient
